import { t } from '@/translations/i18n';
import { setLocale } from 'yup';

function initValidators() {
    setLocale({
        mixed: {
            required: t('validator_mandatory_field'),
            notType: t('validator_type'),
        },
        string: {
            min: t('validator_min', { min: '{min}' }),
        },
    });
}

export { initValidators };
